import { render } from "./localization-settings.vue?vue&type=template&id=6b4dcce7"
import script from "./localization-settings.vue?vue&type=script&lang=js"
export * from "./localization-settings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__